diy.angular.registerDirective('diyfmtoolbar', [ '$compile',
function($compile) {
    
    var spacerTpl = '<div class="fm-toolbar-spacer"></div>';
    var separatorTpl = '<div class="fm-toolbar-sep"></div>';
    
    function getItemTemplate(item) {
        switch (item) {
            case ' ':
                return '<div class="fm-toolbar-spacer"></div>';
            case '-': 
                return '<div class="fm-toolbar-sep"></div>';
            case 'search':
                return '<div diyfmtoolbarsearch></div>';
            case 'selectall':
                return '<div diyfmtoolbarselectall></div>';
            default:
                if (typeof item === 'function') {
                    return item();
                }
        }
        return '';
    }

    return {
        template: '',
        restrict: 'A',
        scope: {
            items: '=diyfmtoolbar'
        },
        link: function(scope, elem, attr) {
            
            scope.$watch('items', function(newItems, oldItems){
                if (newItems) {
                    var tpl = '';
                    for (var i = 0; i < newItems.length; i++) {
                        tpl += getItemTemplate(newItems[i]);
                    }
                    elem.empty();
                    elem.html(tpl);
                    $compile(elem.contents())(scope);
                } else if (oldItems) {
                    elem.empty();
                    $compile(elem.contents())(scope);
                }
            });
            
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmtoolbar.js
 ** module id = 969
 ** module chunks = 0
 **/